import { render, staticRenderFns } from "./LinkHelper.vue?vue&type=template&id=1351005c&scoped=true&"
import script from "./LinkHelper.vue?vue&type=script&lang=js&"
export * from "./LinkHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351005c",
  null
  
)

export default component.exports